module.exports = __webpack_public_path__ + "static/media/lottery-before.8d9ed6d5.png";